export function isLikelyExpiredUrlError(error: Error): boolean {
  const message = error.message.toLowerCase();
  return (
    message.includes('403') ||
    message.includes('404') ||
    message.includes('request has expired') ||
    message.includes('failed to fetch')
  );
}
